import React, { useEffect, useRef, useState } from "react"
import { withRouter, useParams } from "react-router-dom"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import {
  // Alert,
  //Container,
  Row,
  Col,
  UncontrolledTooltip,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  // Table,
  // Badge
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import { MultiSelect } from "react-multi-select-component"
import { useSelector } from "react-redux"
import * as questionAction from "../../store/Y2hlY2tsaX/actions"
import * as clientChecklistAction from "../../store/ZWNDbGllbnRDaGVja2xpc3Q/actions"
import { isEmpty } from "lodash"
import Collapse from "react-bootstrap/Collapse"
import { toast } from "react-toastify"
import moment from "moment"
import SimpleReactValidator from "simple-react-validator"
// import moment from "moment"

const EcClientCheckList = (props) => {
  let { id } = useParams()
  const { dispatch, modeMenu } = props

  //Validations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  useEffect(() => {
    dispatch(questionAction.loadRecords())
    dispatch(questionAction.loadCheckList(id))
    dispatch(clientChecklistAction.loadClientChecklistAnswer(id))
  }, [])

  const update = useSelector(
    (specificstate) => specificstate.check_list_question
  )

  const { checklistData = [] } = update

  // console.log(checklistData, "checklistdata")

  const collapseData = !isEmpty(checklistData) ? checklistData : []

  //State maintains
  const [checkDetails, setCheckDetails] = useState([
    {
      checkListQuestionId: "",
      question: "",
      choose: "",
      eventChoose: "",
      chooseAnswer: "",
      eventChooseAnswer: "",
      isMandatory: "",
      description: "",
      options: "",
      questionType: "",
      groupName: "",
      eventDescription: "",
    },
  ])

  const [collapseDetails, setCollapseDetails] = useState("")

  // const [eventTime, setEventTime] = useState("")
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [renderPage, setRenderPage] = useState(false)
  const [eventTimingsLength, setEventTimingsLength] = useState("")
  const [tableFilterOpt, setTableFilterOpt] = useState([])
  const [eventSameModal, setEventSameModal] = useState(false)
  const handleEventSameModal = () => setEventSameModal(false)

  //Event Time

  const eventStartTimeData = moment(collapseDetails.startTime, [
    "HH.mm",
  ]).format("hh:mm a")
  const eventEndTimeData = moment(collapseDetails.endTime, ["HH.mm"]).format(
    "hh:mm a"
  )
  const crewAssemblyTimeData = moment(collapseDetails.crewAssemblyTime, [
    "HH.mm",
  ]).format("hh:mm a")

  //Onchange functionality

  const [questionId, setQuestionId] = useState("")

  const handleQuestion = async (e, index, id, name, data) => {
    var checkValue = checkDetails
    console.log(index)
    console.log(e, "event is")
    console.log(index)
    if (name == "choose") {
      e = e.target.checked
      checkValue[index][name] = e ? data.option : ""

      console.log(e, "choose change")
      console.log(data, "data choose option")
      // console.log(data.option, "data option")
      console.log(checkValue, "checkValue")
      setQuestionId(id)
      setCheckDetails(checkValue)
    }
    if (name == "eventChoose") {
      e = e.target.checked
      checkValue[index][name] = e ? data.option : ""
      // checkValue[index][name] = data.option

      console.log(e, "eventChoose change")
      console.log(data.option, "data option")
      setCheckDetails(checkValue)
    }
    if (name == "description") {
      e = e.target.value
      checkValue[index][name] = e

      console.log(e, "description")
      setCheckDetails(checkValue)
    }
    if (name == "eventDescription") {
      e = e.target.value
      checkValue[index][name] = e
      console.log(e, "eventDescription")
      setCheckDetails(checkValue)
    }
    setRenderPage(!renderPage)
  }

  //Event same as section start

  //Commit options
  const commitOptions = !isEmpty(collapseData)
    ? collapseData.map((data) => {
        if (collapseDetails.eventId !== data.eventId) {
          return {
            label: data.eventNo,
            value: data.eventId,
          }
        }
      })
    : []

  //Event same as options
  const eventSameOptions =
    !isEmpty(commitOptions) && commitOptions.length > 0
      ? commitOptions.filter((data) => data !== undefined)
      : []

  useEffect(() => {
    if (eventSameModal === false && tableFilterOpt.length > 0) {
      setLoading(true)
      setTimeout(() => {
        const equipmentDataList = collapseData.map((data) => {
          if (data.eventNo === tableFilterOpt[0].label) {
            return data
          }
        })
        const equipmentEventSameOptions = !isEmpty(equipmentDataList)
          ? equipmentDataList.filter((data) => data !== undefined)
          : []
        console.log(equipmentEventSameOptions, "equipmentEventSameOptions")
        const clientQuestionsArray =
          !isEmpty(equipmentEventSameOptions) &&
          equipmentEventSameOptions.length > 0
            ? equipmentEventSameOptions[0].questionDetails.map((data) => {
                if (
                  data.status === 1 &&
                  data.groupName === "Other Event Details"
                ) {
                  const answerData =
                    !isEmpty(data.answer) && data.answer.length > 0
                      ? data.answer[data.answer.length - 1]
                      : ""

                  console.log(answerData, "answerData")
                  const answerChooseDetails =
                    !isEmpty(data.answer) &&
                    data.answer.length > 0 &&
                    data.questionType == "choose"
                      ? data.options.find(
                          (option) => option.option === answerData.answer
                        )
                      : ""

                  console.log(answerChooseDetails, "answerChooseDetails")
                  const answerDescriptionDetails =
                    !isEmpty(data.answer) &&
                    data.answer.length > 0 &&
                    data.questionType === "description"
                      ? data.answer[data.answer.length - 1].answer
                      : ""
                  return {
                    checkListQuestionId: data._id,
                    question: data.question,
                    choose:
                      data.questionType == "choose" &&
                      !isEmpty(answerChooseDetails)
                        ? answerChooseDetails.option
                        : "",
                    chooseAnswer:
                      data.questionType == "choose" &&
                      !isEmpty(answerChooseDetails)
                        ? answerChooseDetails.option
                        : "",
                    eventChoose: "",
                    isMandatory: data.isMandatory,
                    description:
                      data.questionType === "description"
                        ? answerDescriptionDetails
                        : "",
                    options: data.questionType === "choose" ? data.options : [],
                    questionType: data.questionType,
                    groupName: data.groupName,
                    eventDescription: "",
                  }
                }
              })
            : []
        const clientQuestionsEventTimeArray =
          !isEmpty(equipmentEventSameOptions) &&
          equipmentEventSameOptions.length > 0
            ? equipmentEventSameOptions[0].questionDetails.map((data) => {
                if (data.status === 1 && data.groupName === "Event Timings") {
                  const answerData =
                    !isEmpty(data.answer) && data.answer.length > 0
                      ? data.answer[data.answer.length - 1]
                      : ""

                  console.log(answerData, "answerData")
                  const answerChooseDetails =
                    !isEmpty(data.answer) &&
                    data.answer.length > 0 &&
                    data.questionType == "choose"
                      ? data.options.find(
                          (option) => option.option === answerData.answer
                        )
                      : ""
                  console.log(answerChooseDetails, "answerChooseDetails")
                  const answerDescriptionDetails =
                    !isEmpty(data.answer) &&
                    data.answer.length > 0 &&
                    data.questionType === "description"
                      ? data.answer[data.answer.length - 1].answer
                      : ""
                  return {
                    checkListQuestionId: data._id,
                    question: data.question,
                    choose: "",
                    eventChooseAnswer:
                      data.questionType == "choose" &&
                      !isEmpty(answerChooseDetails)
                        ? answerChooseDetails.option
                        : "",
                    eventChoose:
                      data.questionType == "choose" &&
                      !isEmpty(answerChooseDetails)
                        ? answerChooseDetails.option
                        : "",
                    isMandatory: data.isMandatory,
                    description: "",
                    options: data.questionType === "choose" ? data.options : [],
                    questionType: data.questionType,
                    groupName: data.groupName,
                    eventDescription:
                      data.questionType === "description"
                        ? answerDescriptionDetails
                        : "",
                  }
                }
              })
            : []
        console.log(
          clientQuestionsEventTimeArray,
          "clientQuestionsEventTimeArray"
        )
        console.log(clientQuestionsArray, "clientQuestionsArray")
        const eventTimingsArray =
          !isEmpty(equipmentEventSameOptions) &&
          equipmentEventSameOptions.length > 0
            ? equipmentEventSameOptions[0].questionDetails.map((data) => {
                if (data.groupName == "Event Timings") {
                  const answerData =
                    !isEmpty(data.answer) && data.answer.length > 0
                      ? data.answer[data.answer.length - 1]
                      : ""

                  console.log(answerData, "answerData")
                  const answerChooseDetails =
                    !isEmpty(data.answer) &&
                    data.answer.length > 0 &&
                    data.questionType == "choose"
                      ? data.options.find(
                          (option) => option.option === answerData.answer
                        )
                      : ""
                  console.log(answerChooseDetails, "answerChooseDetails")
                  const answerDescriptionDetails =
                    !isEmpty(data.answer) &&
                    data.answer.length > 0 &&
                    data.questionType === "description"
                      ? data.answer[0].answer
                      : ""
                  return {
                    checkListQuestionId: data._id,
                    question: data.question,
                    choose: "",
                    eventChoose:
                      data.questionType == "choose" &&
                      !isEmpty(answerChooseDetails)
                        ? answerChooseDetails.option
                        : "",
                    isMandatory: data.isMandatory,
                    description: "",
                    options: data.questionType === "choose" ? data.options : [],
                    questionType: data.questionType,
                    groupName: data.groupName,
                    eventDescription:
                      data.questionType === "description"
                        ? answerDescriptionDetails
                        : "",
                  }
                }
              })
            : []
        const clientOtherEventArrayDetails = !isEmpty(clientQuestionsArray)
          ? clientQuestionsArray.filter((data) => data !== undefined)
          : []
        const clientQuestionsEventTimeArrayDetails = !isEmpty(
          clientQuestionsEventTimeArray
        )
          ? clientQuestionsEventTimeArray.filter((data) => data !== undefined)
          : []

        const clientQuestionsArrayDetails =
          !isEmpty(clientOtherEventArrayDetails) &&
          !isEmpty(clientQuestionsEventTimeArrayDetails)
            ? clientOtherEventArrayDetails.concat(
                clientQuestionsEventTimeArrayDetails
              )
            : !isEmpty(clientOtherEventArrayDetails) &&
              isEmpty(clientQuestionsEventTimeArrayDetails)
            ? clientOtherEventArrayDetails
            : !isEmpty(clientQuestionsEventTimeArrayDetails) &&
              isEmpty(clientOtherEventArrayDetails)
            ? clientQuestionsEventTimeArrayDetails
            : []

        const eventTimingLengthArray = !isEmpty(eventTimingsArray)
          ? eventTimingsArray.filter((data) => data !== undefined)
          : []

        console.log(
          clientOtherEventArrayDetails,
          "clientOtherEventArrayDetails"
        )
        console.log(eventTimingLengthArray, "eventTimingLengthArray")
        console.log(clientQuestionsArrayDetails, "clientQuestionsArrayDetails")
        // const otherEventDetailsData = !isEmpty(clientQuestionsArray)
        setEventTimingsLength(eventTimingLengthArray)
        setCheckDetails(clientQuestionsArrayDetails)
        setLoading(false)
      }, 1500)
    }
  }, [eventSameModal])

  //Event same as section end

  //Questions details split fucntionality

  useEffect(() => {
    if (open === true) {
      const clientQuestionsArray =
        !isEmpty(collapseDetails) &&
        collapseDetails.questionDetails &&
        collapseDetails.questionDetails.length > 0
          ? collapseDetails.questionDetails.map((data) => {
              if (data.status == 1 && data.groupName == "Other Event Details") {
                console.log(data, "data answer choose")

                const answerData =
                  !isEmpty(data.answer) && data.answer.length > 0
                    ? data.answer[data.answer.length - 1]
                    : ""

                console.log(answerData, "answerData")
                const answerChooseDetails =
                  !isEmpty(data.answer) &&
                  data.answer.length > 0 &&
                  data.questionType == "choose"
                    ? data.options.find(
                        (option) => option.option === answerData.answer
                      )
                    : ""

                console.log(answerChooseDetails, "answerChooseDetails")
                const answerDescriptionDetails =
                  !isEmpty(data.answer) &&
                  data.answer.length > 0 &&
                  data.questionType === "description"
                    ? data.answer[data.answer.length - 1].answer
                    : ""
                return {
                  checkListQuestionId: data._id,
                  question: data.question,
                  choose:
                    data.questionType == "choose" &&
                    !isEmpty(answerChooseDetails)
                      ? answerChooseDetails.option
                      : "",
                  chooseAnswer:
                    data.questionType == "choose" &&
                    !isEmpty(answerChooseDetails)
                      ? answerChooseDetails.option
                      : "",
                  eventChoose: "",
                  isMandatory: data.isMandatory,
                  description:
                    data.questionType === "description"
                      ? answerDescriptionDetails
                      : "",
                  options: data.questionType === "choose" ? data.options : [],
                  questionType: data.questionType,
                  groupName: data.groupName,
                  eventDescription: "",
                }
              }
            })
          : []
      const clientQuestionsEventTimeArray =
        !isEmpty(collapseDetails) &&
        collapseDetails.questionDetails &&
        collapseDetails.questionDetails.length > 0
          ? collapseDetails.questionDetails.map((data) => {
              if (data.status == 1 && data.groupName == "Event Timings") {
                const answerData =
                  !isEmpty(data.answer) && data.answer.length > 0
                    ? data.answer[data.answer.length - 1]
                    : ""

                console.log(answerData, "answerData")
                const answerChooseDetails =
                  !isEmpty(data.answer) &&
                  data.answer &&
                  data.answer.length > 0 &&
                  data.questionType == "choose"
                    ? data.options.find(
                        (option) => option.option === data.answer[0].answer
                      )
                    : ""
                console.log(answerChooseDetails, "answerChooseDetails")
                const answerDescriptionDetails =
                  !isEmpty(data.answer) &&
                  data.answer.length > 0 &&
                  data.questionType === "description"
                    ? data.answer[data.answer.length - 1].answer
                    : ""
                return {
                  checkListQuestionId: data._id,
                  question: data.question,
                  choose: "",
                  eventChooseAnswer:
                    data.questionType == "choose" &&
                    !isEmpty(answerChooseDetails)
                      ? answerChooseDetails.option
                      : "",
                  eventChoose:
                    data.questionType == "choose" &&
                    !isEmpty(answerChooseDetails)
                      ? answerChooseDetails.option
                      : "",
                  isMandatory: data.isMandatory,
                  description: "",
                  options: data.questionType === "choose" ? data.options : [],
                  questionType: data.questionType,
                  groupName: data.groupName,
                  eventDescription:
                    data.questionType === "description"
                      ? answerDescriptionDetails
                      : "",
                }
              }
            })
          : []
      const eventTimingsArray =
        !isEmpty(collapseDetails) &&
        collapseDetails.questionDetails &&
        collapseDetails.questionDetails.length > 0
          ? collapseDetails.questionDetails.map((data) => {
              if (data.groupName == "Event Timings") {
                const answerData =
                  !isEmpty(data.answer) && data.answer.length > 0
                    ? data.answer[data.answer.length - 1]
                    : ""

                console.log(answerData, "answerData")
                const answerChooseDetails =
                  !isEmpty(data.answer) &&
                  data.answer &&
                  data.answer.length > 0 &&
                  data.questionType == "choose"
                    ? data.options.find(
                        (option) => option.option === data.answer[0].answer
                      )
                    : ""
                const answerDescriptionDetails =
                  !isEmpty(data.answer) &&
                  data.answer.length > 0 &&
                  data.questionType == "description"
                    ? data.answer[0].answer
                    : ""
                return {
                  checkListQuestionId: data._id,
                  question: data.question,
                  choose: "",
                  eventChooseAnswer:
                    data.questionType == "choose" ? answerChooseDetails : "",
                  eventChoose:
                    data.questionType == "choose" ? answerChooseDetails : "",
                  isMandatory: data.isMandatory,
                  description: "",
                  options: data.questionType === "choose" ? data.options : [],
                  questionType: data.questionType,
                  groupName: data.groupName,
                  eventDescription:
                    data.questionType === "description"
                      ? answerDescriptionDetails
                      : "",
                }
              }
            })
          : []

      const eventTimingLengthArray = !isEmpty(eventTimingsArray)
        ? eventTimingsArray.filter((data) => data !== undefined)
        : []
      const clientOtherEventArrayDetails = !isEmpty(clientQuestionsArray)
        ? clientQuestionsArray.filter((data) => data !== undefined)
        : []
      const clientQuestionsEventTimeArrayDetails = !isEmpty(
        clientQuestionsEventTimeArray
      )
        ? clientQuestionsEventTimeArray.filter((data) => data !== undefined)
        : []

      const clientQuestionsArrayDetails =
        !isEmpty(clientOtherEventArrayDetails) &&
        !isEmpty(clientQuestionsEventTimeArrayDetails)
          ? clientOtherEventArrayDetails.concat(
              clientQuestionsEventTimeArrayDetails
            )
          : !isEmpty(clientOtherEventArrayDetails) &&
            isEmpty(clientQuestionsEventTimeArrayDetails)
          ? clientOtherEventArrayDetails
          : !isEmpty(clientQuestionsEventTimeArrayDetails) &&
            isEmpty(clientOtherEventArrayDetails)
          ? clientQuestionsEventTimeArrayDetails
          : []
      console.log(eventTimingLengthArray, "eventTimingLengthArray")
      console.log(
        clientQuestionsEventTimeArrayDetails,
        "clientQuestionsEventTimeArrayDetails"
      )
      console.log(clientOtherEventArrayDetails, "clientOtherEventArrayDetails")
      console.log(clientQuestionsArrayDetails, "clientQuestionArrayDetails")
      console.log(clientQuestionsArray, "clientQuestionsArray")
      // const otherEventDetailsData = !isEmpty(clientQuestionsArray)
      setEventTimingsLength(eventTimingLengthArray)
      setCheckDetails(clientQuestionsArrayDetails)
      setTableFilterOpt([])
    }
  }, [open])

  console.log(checkDetails, "checkDetails")
  console.log(questionId, "questionId")

  //Collapse bar section end
  const handleSubmit = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const descriptionCheck =
        !isEmpty(checkDetails) &&
        checkDetails.map((data) => {
          // console.log(data.value, "mydescriptions")
          if (
            data.questionType === "description" &&
            isEmpty(data.eventDescription) &&
            isEmpty(data.eventChoose) &&
            !isEmpty(data.description)
          ) {
            console.log(data.description, "descriptions")
            return {
              // eventId: data.eventId,
              checkListQuestionId: data.checkListQuestionId,
              // mode: "single",
              answer: data.description,
            }
          }
        })
      const descriptionChecklist = !isEmpty(descriptionCheck)
        ? descriptionCheck.filter((data) => data !== undefined)
        : []
      // console.log(descriptionCheck, "descriptionCheck")
      const chooseCheck =
        !isEmpty(checkDetails) &&
        checkDetails.map((data) => {
          // console.log(data, "choose type")
          if (
            data.questionType == "choose" &&
            data.groupName == "Other Event Details"
            // isEmpty(data.eventChoose) &&
            // isEmpty(data.description)
            // !isEmpty(data.choose) &&
            // data.checkListQuestionId == questionId
          ) {
            console.log("choose type", data.choose)
            return {
              // eventId: data.eventId,
              checkListQuestionId: data.checkListQuestionId,
              // mode: "single",
              answer: !isEmpty(data.choose) ? data.choose : "",
            }
          }
        })

      console.log(chooseCheck, "chooseCheck")
      const chooseChecklist = !isEmpty(chooseCheck)
        ? chooseCheck.filter((data) => data !== undefined)
        : []
      // console.log(chooseCheck, "chooseCheck")

      const eventChooseCheck =
        !isEmpty(checkDetails) &&
        checkDetails.map((data) => {
          console.log(data.value, "mydescriptions")
          if (
            isEmpty(data.eventDescription) &&
            isEmpty(data.choose) &&
            data.questionType == "choose" &&
            !isEmpty(data.eventChoose) &&
            isEmpty(data.description)
          ) {
            // console.log("datachoosedata", data.choose)
            return {
              // eventId: data.eventId,
              checkListQuestionId: data.checkListQuestionId,
              // mode: "single",
              answer: data.eventChoose,
            }
          }
        })
      console.log(eventChooseCheck, "eventChooseCheck")
      const eventChooseChecklist = !isEmpty(eventChooseCheck)
        ? eventChooseCheck.filter((data) => data !== undefined)
        : []

      const eventTimeCheck =
        !isEmpty(checkDetails) &&
        checkDetails.map((data) => {
          // console.log(data.value, "mydescriptions")
          if (
            !isEmpty(data.eventDescription) &&
            data.groupName == "Event Timings"
          ) {
            // console.log("datachoosedata", data.choose)
            return {
              // eventId: data.eventId,
              checkListQuestionId: data.checkListQuestionId,
              // mode: "single",
              answer: data.eventDescription,
            }
          }
        })
      // console.log(eventTimeCheck, "eventTimeCheck")
      const eventTimeChecklist = !isEmpty(eventTimeCheck)
        ? eventTimeCheck.filter((data) => data !== undefined)
        : []

      // const otherEventsDetailsList =
      //   !isEmpty(descriptionChecklist) && !isEmpty(chooseChecklist)
      //     ? descriptionChecklist.concat(chooseChecklist)
      //     : []
      const otherEventsDetailsList =
        !isEmpty(descriptionChecklist) && !isEmpty(chooseChecklist)
          ? descriptionChecklist.concat(chooseChecklist)
          : !isEmpty(descriptionChecklist) && isEmpty(chooseChecklist)
          ? descriptionChecklist
          : !isEmpty(chooseChecklist) && isEmpty(descriptionChecklist)
          ? chooseChecklist
          : []
      const eventTimingsList =
        !isEmpty(eventChooseChecklist) && !isEmpty(eventTimeChecklist)
          ? eventTimeChecklist.concat(eventChooseChecklist)
          : isEmpty(eventChooseChecklist) && !isEmpty(eventTimeChecklist)
          ? eventTimeChecklist
          : !isEmpty(eventChooseChecklist) && isEmpty(eventTimeChecklist)
          ? eventChooseChecklist
          : []

      console.log(otherEventsDetailsList, "otherEventsDetailsList")
      console.log(eventTimingsList, "eventTimingsList")

      const checklist =
        !isEmpty(otherEventsDetailsList) && !isEmpty(eventTimingsList)
          ? otherEventsDetailsList.concat(eventTimingsList)
          : isEmpty(otherEventsDetailsList) && !isEmpty(eventTimingsList)
          ? eventTimingsList
          : !isEmpty(otherEventsDetailsList) && isEmpty(eventTimingsList)
          ? otherEventsDetailsList
          : []

      const checklistAnswer = {
        leadId: id,
        eventId: collapseDetails.eventId,
        leadeventId: collapseDetails.leadEventId,
        answerDetails: checklist.filter((data) => data !== undefined),
      }

      dispatch(clientChecklistAction.addClientChecklistAnswer(checklistAnswer))
      setTimeout(() => {
        toast.success("Records Submitted Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setOpen(false)
        dispatch(questionAction.loadCheckList(id))
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setOpen(true)
    }
    // console.log(checklistAnswer, "myans")
  }

  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <Col md="12" lg="12" sm="12">
          <p className="quote-head" style={{ fontSize: "20px" }}>
            Client CheckList
          </p>
        </Col>
      </Row>
      <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-2">
        <div
          style={{ marginLeft: "10px", marginRight: "10px", marginTop: "20px" }}
        >
          {!isEmpty(collapseData) && collapseData.length > 0 ? (
            collapseData.map((data) => {
              console.log(data, "data from collpase Data")
              return (
                <Row className="question-card-content mb-1" key={data._id}>
                  <Col>
                    <p
                      style={{
                        fontSize: "15px",
                        marginBottom: "12px",
                        // padding: "0px 8px",
                        fontWeight: 550,
                        marginTop: "10px",
                      }}
                    >
                      {data.eventNo}
                    </p>
                  </Col>

                  <Col>
                    {/* {modeMenu === "EventComplete" ? (
                      ""
                    ) : ( */}
                    <div
                      style={{
                        color: "#291213",
                        height: "22px",
                        width: "max-content",
                        textAlign: "center",
                        cursor: "pointer",
                        fontSize: "24px",
                        marginTop: "10px",
                        float: "right",
                        display: "flex",
                      }}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                      onClick={() => {
                        if (data.leadEventId) {
                          setCollapseDetails(data)
                          setOpen(!open)
                        }
                      }}
                    >
                      <i className="fas fa-angle-down"></i>
                    </div>
                    {/* )} */}
                  </Col>
                  <Collapse
                    in={
                      data.leadEventId === collapseDetails.leadEventId && open
                    }
                  >
                    <div id="example-collapse-text">
                      <Row>
                        <Row>
                          <Col md="2" lg="2" sm="2" className="mt-3">
                            <Card
                              style={{
                                border: "2px solid rgb(239, 242, 247)",
                                textAlign: "center",
                                boxShadow:
                                  "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
                              }}
                            >
                              <CardBody>
                                <Row>
                                  <Col sm="12" md="12" lg="12">
                                    <div
                                      style={{
                                        fontSize: "22px",
                                        fontWeight: "bold",
                                        flex: "display",
                                      }}
                                    >
                                      {" "}
                                      Event
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <h1
                                    style={{
                                      color: "#E40D8C",
                                      textAlign: "center",
                                    }}
                                  >
                                    {!isEmpty(collapseDetails)
                                      ? collapseDetails.eventNo.split("Event")
                                      : ""}
                                  </h1>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col md="10" lg="10" sm="10">
                            <Row className="mt-3">
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  {"Event Name :"}
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.eventName)
                                    ? collapseDetails.eventName
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  {"Date :"}
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.eventDate)
                                    ? moment(collapseDetails.eventDate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  {"Start Time :"}
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.startTime)
                                    ? eventStartTimeData
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  End Time:
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.endTime)
                                    ? eventEndTimeData
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Venue Name :
                                </p>
                                <p
                                  style={{
                                    fontWeight: "550",
                                    // width: "max-content",
                                  }}
                                >
                                  {!isEmpty(collapseDetails.venueName)
                                    ? collapseDetails.venueName
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Venue Location:
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.venueLocation)
                                    ? collapseDetails.venueLocation
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Food :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.food)
                                    ? collapseDetails.food
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Travel :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.travel)
                                    ? collapseDetails.travel
                                    : "--"}
                                </p>
                              </Col>

                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Crew Assembly :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.crewAssemblyTime)
                                    ? crewAssemblyTimeData
                                    : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Crowd Strength :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.crowdStrength)
                                    ? collapseDetails.crowdStrength
                                    : "--"}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row
                          // className="question-card-content"
                          style={{ marginTop: "30px" }}
                          // className="d-flex flex-row justify-content-end"
                        >
                          <Col>
                            <div style={{ float: "right", width: "150px" }}>
                              <Label
                                className={"form-label"}
                                style={{ marginBottom: "-4px" }}
                              >
                                Same As
                              </Label>
                              <MultiSelect
                                value={tableFilterOpt}
                                name="tableFilterOpt"
                                onChange={(e) => {
                                  setTableFilterOpt(e)
                                  setEventSameModal(true)
                                }}
                                disabled={
                                  modeMenu === "EventComplete" ? true : false
                                }
                                options={eventSameOptions}
                                labelledBy="Select Event"
                                hasSelectAll={true}
                                className={
                                  modeMenu === "EventComplete"
                                    ? "disabled-button"
                                    : ""
                                }
                              />
                            </div>
                          </Col>

                          {/* <span>Event</span>{" "}
                                <i className="fas fa-angle-down mx-3 font-size-18"></i> */}
                        </Row>
                        <Row
                          className={
                            open &&
                            !isEmpty(collapseDetails.questionDetails) &&
                            collapseDetails.questionDetails[0].groupName ===
                              "Other Event Details"
                              ? "quote-head-content"
                              : ""
                          }
                        >
                          <Col md="12" lg="12" sm="12">
                            <p className="quote-head">
                              {open &&
                              !isEmpty(collapseDetails.questionDetails) &&
                              collapseDetails.questionDetails[0].groupName ===
                                "Other Event Details" &&
                              checkDetails.length > 0
                                ? "Other Event Details"
                                : "No Question Details Record Found..."}
                              {!isEmpty(collapseDetails.questionDetails) &&
                              collapseDetails.questionDetails[0].groupName ===
                                "Other Event Details" &&
                              checkDetails.length > 0 ? (
                                <span className="quote-info">
                                  <i
                                    style={{ color: "grey" }}
                                    id="quoteInfo1"
                                    aria-hidden="true"
                                    className="fa fa-info-circle ms-1"
                                  ></i>

                                  <UncontrolledTooltip
                                    placement="right"
                                    target="quoteInfo1"
                                  >
                                    {!isEmpty(collapseDetails.questionDetails)
                                      ? collapseDetails.questionDetails[0]
                                          .groupName === "Other Event Details"
                                        ? "Other Event Details"
                                        : ""
                                      : ""}
                                  </UncontrolledTooltip>
                                </span>
                              ) : (
                                ""
                              )}
                            </p>
                          </Col>
                        </Row>
                        <Row className="mt-3" style={{ marginBottom: "20px" }}>
                          {!isEmpty(checkDetails) &&
                            checkDetails.length > 0 &&
                            checkDetails.map((data, index) => {
                              const choose =
                                !isEmpty(data.options) &&
                                data.options &&
                                data.options.length > 0
                                  ? data.options
                                  : []
                              const chooseDetails = !isEmpty(choose)
                                ? choose.filter((el) => {
                                    return el != null
                                  })
                                : []
                              if (data.groupName == "Other Event Details") {
                                console.log(data, "data")
                                return (
                                  <>
                                    <Col
                                      key={data.checkListQuestionId}
                                      xl="6"
                                      lg="6"
                                      md="6"
                                      sm="6"
                                      xs="6"
                                      className="mt-2"
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <Label className="employee-label">
                                        {data.question}
                                        {data.isMandatory === "true" ? (
                                          <span
                                            style={{ marginLeft: "5px" }}
                                            className="required"
                                          >
                                            *
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </Label>
                                      {data.questionType === "choose" ? (
                                        <>
                                          {!isEmpty(chooseDetails) &&
                                            chooseDetails.map((chooseData) => {
                                              console.log(
                                                chooseData,
                                                "chooseData"
                                              )
                                              return (
                                                <div
                                                  key={data.checkListQuestionId}
                                                  className="d-flex flex-row"
                                                >
                                                  <Input
                                                    type="checkbox"
                                                    name="choose"
                                                    disabled={
                                                      modeMenu ===
                                                      "EventComplete"
                                                        ? true
                                                        : false
                                                    }
                                                    defaultChecked={
                                                      // !isEmpty(data.choose) &&
                                                      data.choose ===
                                                        chooseData.option ||
                                                      chooseData.option ===
                                                        data.chooseAnswer
                                                        ? true
                                                        : false
                                                    }
                                                    className={
                                                      modeMenu ===
                                                      "EventComplete"
                                                        ? "disabled-button"
                                                        : ""
                                                    }
                                                    value={data.choose}
                                                    onChange={(e) =>
                                                      handleQuestion(
                                                        e,
                                                        index,
                                                        data.checkListQuestionId,
                                                        "choose",
                                                        chooseData
                                                      )
                                                    }
                                                  />{" "}
                                                  <Label className="mx-2">
                                                    {chooseData.option}
                                                  </Label>
                                                  <></>
                                                </div>
                                              )
                                            })}
                                          {/* {isEmpty(data.choose) ? ( */}
                                            <>
                                              {simpleValidator.current.message(
                                                "choose",
                                                data.choose,
                                                "required"
                                              )}
                                            </>
                                          {/* ) : (
                                            // ""
                                          )} */}
                                        </>
                                      ) : (
                                        <>
                                          {" "}
                                          <Input
                                            type="text"
                                            name="description"
                                            value={data.description}
                                            onChange={(e) =>
                                              handleQuestion(
                                                e,
                                                index,
                                                data.checkListQuestionId,
                                                "description"
                                              )
                                            }
                                            disabled={
                                              modeMenu === "EventComplete"
                                                ? true
                                                : false
                                            }
                                            placeholder="Enter Description"
                                            classNamePrefix="select2-selection"
                                          />
                                          {data.isMandatory === "true" ? (
                                            <>
                                              {simpleValidator.current.message(
                                                "description",
                                                data.description,
                                                "required"
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      )}
                                    </Col>
                                  </>
                                )
                              } else {
                                return ""
                              }
                            })}
                        </Row>
                        {!isEmpty(eventTimingsLength) &&
                        eventTimingsLength.length > 0 ? (
                          <>
                            <Row className="quote-head-content">
                              <Col md="3" lg="3" sm="3">
                                <p className="quote-head">
                                  {!isEmpty(eventTimingsLength) &&
                                  eventTimingsLength.length > 0
                                    ? "Event Timings"
                                    : ""}

                                  {!isEmpty(eventTimingsLength) &&
                                  eventTimingsLength.length > 0 ? (
                                    <span className="quote-info">
                                      <i
                                        style={{ color: "grey" }}
                                        id="quoteInfo1"
                                        aria-hidden="true"
                                        className="fa fa-info-circle ms-1"
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="right"
                                        target="quoteInfo1"
                                      >
                                        {"Event Timings"}
                                      </UncontrolledTooltip>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              {!isEmpty(checkDetails) && checkDetails.length > 0
                                ? checkDetails.map((data, index) => {
                                    const choose =
                                      !isEmpty(data.options) &&
                                      data.options &&
                                      data.options.length > 0
                                        ? data.options
                                        : []
                                    const chooseDetails = !isEmpty(choose)
                                      ? choose.filter((el) => {
                                          return el != null
                                        })
                                      : []
                                    if (data.groupName == "Event Timings") {
                                      return (
                                        <Col
                                          key={index}
                                          xl="6"
                                          lg="6"
                                          md="6"
                                          sm="6"
                                          xs="6"
                                          className="mt-2"
                                          style={{ marginBottom: "10px" }}
                                        >
                                          <Label className="employee-label">
                                            {data.question}
                                            {data.isMandatory === "true" ? (
                                              <span
                                                style={{ marginLeft: "5px" }}
                                                className="required"
                                              >
                                                *
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </Label>
                                          {data.questionType === "choose" ? (
                                            <>
                                              {!isEmpty(chooseDetails) &&
                                                chooseDetails.map(
                                                  (chooseData, index) => {
                                                    console.log(
                                                      chooseData,
                                                      "chooseData"
                                                    )
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="d-flex flex-row"
                                                      >
                                                        <Input
                                                          type="radio"
                                                          name="eventChoose"
                                                          defaultChecked={
                                                            !isEmpty(
                                                              data.eventChoose
                                                            ) &&
                                                            data.eventChoose ==
                                                              chooseData.option
                                                              ? true
                                                              : false
                                                          }
                                                          disabled={
                                                            modeMenu ===
                                                            "EventComplete"
                                                              ? true
                                                              : false
                                                          }
                                                          // checked={
                                                          //   data.eventChoose ==
                                                          //   data.eventChooseAnswer
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          value={
                                                            data.eventChoose
                                                          }
                                                          onChange={(e) =>
                                                            handleQuestion(
                                                              e,
                                                              index,
                                                              data.checkListQuestionId,
                                                              "eventChoose",
                                                              chooseData
                                                            )
                                                          }
                                                        />{" "}
                                                        <Label className="mx-2">
                                                          {chooseData.option}
                                                        </Label>
                                                      </div>
                                                    )
                                                  }
                                                )}
                                              {data.isMandatory === "true" ? (
                                                <>
                                                  {simpleValidator.current.message(
                                                    "eventChoose",
                                                    data.eventChoose,
                                                    "required"
                                                  )}
                                                </>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <Input
                                                type="text"
                                                name="eventDescription"
                                                value={data.eventDescription}
                                                onChange={(e) =>
                                                  handleQuestion(
                                                    e,
                                                    index,
                                                    data.checkListQuestionId,
                                                    "eventDescription"
                                                  )
                                                }
                                                disabled={
                                                  modeMenu === "EventComplete"
                                                    ? true
                                                    : false
                                                }
                                                placeholder="Enter The Value"
                                              />
                                              {simpleValidator.current.message(
                                                "eventDescription",
                                                data.eventDescription,
                                                "required"
                                              )}
                                            </>
                                          )}
                                        </Col>
                                      )
                                    }
                                    // else {
                                    //   return ""
                                    // }
                                  })
                                : ""}
                            </Row>
                          </>
                        ) : (
                          ""
                        )}
                        <Col className="mt-3">
                          <div style={{ float: "right", marginBottom: "20px" }}>
                            <Button
                              type="submit"
                              className={
                                modeMenu === "EventComplete"
                                  ? "disabled-button btn btn-success"
                                  : "btn btn-success"
                              }
                              onClick={(e) => handleSubmit(e)}
                            >
                              Submit
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      {/* // ) */}
                      {/* // } */}
                      {/* // })} */}
                    </div>
                  </Collapse>
                </Row>
              )
            })
          ) : (
            <Row className="question-card-content" key={0}>
              <Col>
                <p
                  style={{
                    fontSize: "15px",
                    marginBottom: "-12px",
                    fontWeight: 550,
                    marginTop: "-1px",
                  }}
                >
                  {"No Events"}
                </p>
              </Col>
              <Col>
                <div
                  style={{
                    color: "#291213",
                    height: "22px",
                    width: "max-content",
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: "24px",
                    float: "right",
                    display: "flex",
                  }}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  onClick={() => {
                    setOpen(!open)
                  }}
                >
                  <i className="fas fa-angle-down"></i>
                </div>
              </Col>
            </Row>
          )}
          {eventSameModal && (
            <Modal
              show={eventSameModal}
              onHide={handleEventSameModal}
              size="md"
              // fullscreen={fullscreen}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Confirm
              </Modal.Header>
              <Modal.Body>
                Do you want to confirm the same as event ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-danger"
                  onClick={() => setEventSameModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-success"
                  onClick={() => setEventSameModal(false)}
                >
                  Commit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {loading ? (
            <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </div>
      </Col>

      {/* <Row style={{ marginTop: "25px" }}></Row> */}
    </React.Fragment>
  )
}

EcClientCheckList.propTypes = {
  dispatch: PropTypes.func,
  modeMenu: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EcClientCheckList)
)
